(function () {
    var typed = '';
    var TRIGGER = 'waste';

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; spawnTristero(); }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/the-crying-of-lot-49')) {
        setTimeout(spawnTristero, 700);
    }

    function spawnTristero() {
        if (document.querySelector('.tristero-overlay')) return;

        var overlay = document.createElement('div');
        overlay.className = 'tristero-overlay';

        var horn = document.createElement('div');
        horn.className = 'tristero-horn';
        horn.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:0.6rem;';
        horn.innerHTML = '<div style="font-family:monospace;font-size:clamp(1.6rem,4vw,2.8rem);letter-spacing:0.55em;color:rgba(172,45,30,0.92);font-weight:700;text-transform:uppercase;">W·A·S·T·E</div>'
            + '<div style="font-family:monospace;font-size:clamp(0.55rem,1.1vw,0.72rem);letter-spacing:0.32em;color:rgba(172,45,30,0.52);text-transform:uppercase;">We Await Silent Tristero\'s Empire</div>';

        var caption = document.createElement('div');
        caption.className = 'tristero-caption';
        caption.textContent = '„Shall I project a world?"';

        overlay.appendChild(horn);
        overlay.appendChild(caption);

        var closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', function () {
            overlay.classList.add('tristero-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        });
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);

        setTimeout(function () {
            overlay.classList.add('tristero-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        }, 4500);
    }
})();
